<template>
  <details class="filter-facet">
    <summary class="filter-facet__header">
      <div class="filter-facet__title">
        <h3 class="filter-facet__title-text">{{ title }}</h3>
        <div class="filter-facet__arrow"></div>
      </div>
      <div class="filter-facet__selected-tags">
        <span v-for="(tag, index) in checkedItems" :key="index">
          {{ tag }}<template v-if="index !== checkedItems.length - 1">, </template>
        </span>
      </div>
    </summary>
    <ul class="filter-facet__list">
      <!-- TODO: move the following element into a standalone component (generic form design update - generic-options.vue) -->
      <template v-for="(facet, f) in facets" :key="f">
        <li v-if="checkFacetTitle(facet.title)" class="filter-facet__list-item">
          <label :for="facet.id" :class="{ '-disabled': facet.disabled || isLoading }">
            <input
              :id="facet.id"
              v-model="checkedItems"
              v-tag:useractionevent.dom="{
                category: category,
                action: 'filter::by needs',
                label: `${title}::${facet.title}`,
                filter_type: 'filter',
                filter_value: `${filterValue.length > 0 ? filterValue : facet.title}`,
                event_name: 'use_filters',
              }"
              type="checkbox"
              :disabled="facet.disabled || isLoading"
              :name="facet.label"
              :value="facet.label"
              @change="
                inputChanged(facet.urlToApiWithParams, facet.urlToShow);
                // Used by OAP CN site
                likecountert();
              "
            />
            <span class="checkmark"></span>
            <span
              class="filter-facet-title"
              :class="{ '-selected': checkedItems.includes(facet.label) }"
            >
              {{ facet.label }}
            </span>
          </label>
        </li>
      </template>
    </ul>
  </details>
</template>

<script>
import { mapGetters } from 'vuex';
import eventBus from '@loreal/eventbus-js';

export default {
  name: 'FilterFacet',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    facets: {
      type: Array,
      default: () => [],
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lastCount: 0,
      difference: 0,
      operation: 'increase',
      category: window.wsf.AnalyticsVariables.pageCategory
        ? window.wsf.AnalyticsVariables.pageCategory
        : 'content page',
      filterValue: '',
    };
  },
  computed: {
    ...mapGetters('filterList', ['selectedTags', 'selectedBrands']),

    checkedItems() {
      let items = [];

      this.facets.forEach((facet) => {
        this.selectedTags.forEach((tag) => {
          if (tag.title === facet.title) {
            items.push(tag.label);
          }
        });
        this.selectedBrands.forEach((brand) => {
          if (brand.title === facet.title) {
            items.push(brand.title);
          }
        });
      });

      return items;
    },
  },
  methods: {
    inputChanged(urlToApiWithParams, urlToShow) {
      eventBus.emit('filterProducts', {
        apiUrl: urlToApiWithParams,
        url: urlToShow,
      });
    },

    // Used by OAP CN site
    likecountert() {
      setTimeout(() => {
        var activeArticles = document.querySelectorAll('.active_like');
        for (var i = 0; i < activeArticles.length; i++) {
          var allarticleIdsActive = activeArticles[i].getAttribute('id');
          var activeId = document.getElementById(allarticleIdsActive);
          activeId.classList.remove('active_like');
        }

        var allAricles = document.querySelectorAll('.like__btn');
        for (let i = 0; i < allAricles.length; i++) {
          var allarticleIdsAll = allAricles[i].getAttribute('id');
          this.allitemsArticle.push(allarticleIdsAll);
        }

        var articlelike = JSON.parse(localStorage.getItem('articlelike'));
        var numberOfChildren = articlelike && articlelike.length;
        if (numberOfChildren > 0) {
          for (let i = 0; i < articlelike.length; i++) {
            for (var j = 0; j < allAricles.length; j++) {
              var allarticleIds = allAricles[j].getAttribute('id');
              var currentItem = articlelike[i];
              if (allarticleIds == currentItem) {
                document.getElementById(articlelike[i]).classList.add('active_like');
              }
            }
          }
        }

        const selectedFilterTags = document.querySelectorAll('.-selected');
        const filterValues = [];
        selectedFilterTags.forEach((item) => {
          if (item.control) {
            // TODO: check why item.control doesn't exist (see filter-tags.vue line 76 for reference)
            filterValues.push(item.control.name);
          }
        });
        this.filterValue = filterValues.join('::');

        fetch(`/api/sitecore/article/GetLikeCountList?&idList=${this.allitemsArticle}`)
          .then((response) => response.json())
          .then((jsonData) => {
            var hideableSections = document.querySelectorAll('.like__btn');
            for (var i = 0; i < hideableSections.length; i++) {
              var allarticleIds = hideableSections[i].getAttribute('id');
              if (jsonData.list[i].likeCount <= 0) {
                document
                  .getElementById(allarticleIds)
                  .getElementsByClassName('like__number')[0].innerHTML = '';
              } else {
                document
                  .getElementById(allarticleIds)
                  .getElementsByClassName('like__number')[0].innerHTML = jsonData.list[i].likeCount;
              }
            }
          })
          .catch((e) => console.error(e));
      }, 2599);
    },

    checkFacetTitle(facetTitle) {
      const uuidRegexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      const isUUID = uuidRegexp.test(facetTitle);

      return !isUUID;
    },
  },
};
</script>
